import { Box } from "@mui/material";
import Admin from "./Admin";

const MessageSent = () => {
    return (<Admin>
        <Box>
        <h1>
            Félicitations et bravo ! <br />
            Vos informations ont été envoyés chez ONPR !
        </h1>
        </Box>
    </Admin>);
}
 
export default MessageSent;